import _                                                     from 'underscore';
import React, { CSSProperties, FC, useLayoutEffect, useRef } from 'react';
import { SidebarProps }                                      from 'semantic-ui-react';

import { SidebarComponent, SidebarComponentProps } from './SidebarComponent';
import { sum }                                     from '../../util';

export interface SidebarDeepContentComponentProps extends Partial<SidebarComponentProps> {
	parentSUIWidth?: SidebarProps['width'] | 'default',
	inset?: number | [ top: number, right: number, bottom: number, left: number ],
	roundedEdges?: number | [ topLeft: number, topRight: number, bottomRight: number, bottomLeft: number ]
}

let defaultProps: SidebarDeepContentComponentProps = {
	parentSUIWidth: 'default',
	inset:          [ 0, 0, 0, 30 ],
	roundedEdges:   0,
};

const SidebarDeepContentComponent: FC<SidebarDeepContentComponentProps> = ( props ) => {
	
	let containerRef = useRef<any>( null );
	
	let [ topInset, rightInset, bottomInset, leftInset ]               = _.isArray( props.inset ) ? props.inset : _.range( 4 ).map( x => props.inset ) as number[],
	    [ topLeftEdge, topRightEdge, bottomRightEdge, bottomLeftEdge ] = _.isArray( props.roundedEdges ) ? props.roundedEdges : _.range( 4 ).map( x => props.roundedEdges ) as number[];
	
	let fitHash: Record<SidebarProps['width'] | 'default', number> = {
		'very thin': 60,
		'thin':      150,
		'default':   260,   // default SUI size
		'wide':      350,
		'very wide': 475,
	};
	
	let parentWidth = fitHash[ props.sidebar[ 0 ]?.props?.width ?? props.parentSUIWidth ?? defaultProps.parentSUIWidth ];
	
	let contentStyle: CSSProperties = {
		top:    topInset,
		bottom: bottomInset,
		width:  `calc(${ parentWidth }px - ${ leftInset }px)`,
		...( props.contentStyle ?? {} )
	};
	
	useLayoutEffect( () => {
		
		// move the actual sidebar down
		if( containerRef.current ){
			
			let [ sidebarEl, parentSidebar ] = containerRef.current;
			
			//{ borderTopLeftRadius: 7 }
			
			let animatesFromLeft     = ( ( parentSidebar.props?.direction ?? null ) === 'left' ),
			    animatesFromRight    = ( ( parentSidebar.props?.direction ?? null ) === 'right' || !parentSidebar.props.direction ),    // default SUI behavior
			    animatesFromTop      = ( ( parentSidebar.props?.direction ?? null ) === 'top' ),
			    animatesFromBottom   = ( ( parentSidebar.props?.direction ?? null ) === 'bottom' ),
			    animatesHorizontally = animatesFromLeft || animatesFromRight,
			    animatesVertically   = animatesFromTop || animatesFromBottom;
			
			if( animatesHorizontally ){
				sidebarEl.style.setProperty( 'top', `${ topInset || 0 }px )`, 'important' );
				sidebarEl.style.setProperty( 'bottom', `${ bottomInset || 0 }px )`, 'important' );
				sidebarEl.style.setProperty( 'height', `calc( 100% - ${ topInset || 0 }px - ${ bottomInset || 0 }px )`, 'important' );
			}
			if( animatesVertically ){
				sidebarEl.style.setProperty( 'left', `${ leftInset || 0 }px )`, 'important' );
				sidebarEl.style.setProperty( 'right', `${ rightInset || 0 }px )`, 'important' );
				sidebarEl.style.setProperty( 'width', `calc(${ parentWidth }px - ${ leftInset }px)`, 'important' );
			}
			
			if( animatesFromTop ){
				
				sidebarEl.style.setProperty( 'bottom', `${ bottomInset || 0 }px`, 'important' );
			}
			
			if( animatesFromBottom ){
				
				sidebarEl.style.setProperty( 'top', `${ topInset || 0 }px`, 'important' );
				
			}
			if( animatesFromLeft ){
				
				sidebarEl.style.setProperty( 'right', `${ rightInset || 0 }px )`, 'important' );
				sidebarEl.style.setProperty( 'width', `calc(${ parentWidth }px - ${ rightInset }px)`, 'important' );
				
			}
			if( animatesFromRight ){
				
				sidebarEl.style.setProperty( 'left', `${ leftInset || 0 }px )`, 'important' );
				sidebarEl.style.setProperty( 'width', `calc(${ parentWidth }px - ${ leftInset }px)`, 'important' );
			}
			
			if( props.roundedEdges ){
				
				sidebarEl.style.setProperty( 'border-radius', `${ topLeftEdge || 0 }px ${ topRightEdge || 0 }px ${ bottomRightEdge || 0 }px ${ bottomLeftEdge || 0 }px`, 'important' );
			}
		}
	} )
	
	let passthroughProps = _.omit.apply( this, [ props, ..._.keys( defaultProps ) ] );
	
	return (
		<SidebarComponent
			{ ...passthroughProps }
			contentStyle={ contentStyle }
			componentRef={ containerRef }
			onAfterLayout={ ref => {
				
				//ref && ref.scrollTo( 0, 0 );
				
			} }>
			
			{ props.children }
		
		</SidebarComponent>
	);
};

SidebarDeepContentComponent.defaultProps = defaultProps;

/* Corval curated sidebar for right side entry, rounded edge on top left, with small inset on top and left */
const CorvalDeepContentSidebar: FC<SidebarDeepContentComponentProps> = ( props ) => <SidebarDeepContentComponent roundedEdges={ [ 7, 0, 0, 0 ] } inset={ [ 10, 0, 0, 20 ] }{ ...props } />

export { SidebarDeepContentComponent, CorvalDeepContentSidebar }
